import { useState, useEffect } from 'react';
import { api } from '@crm/shared';

// Module-level cache — lives for the browser session
let _cache = null;
let _promise = null;

export function invalidateUsersCache() {
  _cache = null;
  _promise = null;
}

export function useAllUsers() {
  const [users,   setUsers]   = useState(_cache || []);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    if (_cache) {
      setUsers(_cache);
      setLoading(false);
      return;
    }
    if (!_promise) {
      _promise = api.getAllActiveUsers()
        .then(res => {
          _cache = Array.isArray(res?.data) ? res.data : [];
          return _cache;
        })
        .catch(() => {
          _promise = null;
          return [];
        });
    }
    _promise.then(data => {
      setUsers(data);
      setLoading(false);
    });
  }, []);

  return { users, loading };
}
